import React from 'react';
import moment from 'moment';
import _ from 'lodash';
import shortid from 'shortid';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Modal from 'react-modal';
const { URL_PREFIX } = window;

const getLastDayOfMonth = (year, month) => new Date(year, month, 0).getDate();

function weekOfMonth(input = moment()) {
    const firstDayOfMonth = input.clone().startOf('month');
    const firstDayOfWeek = firstDayOfMonth.clone().startOf('week');

    const offset = firstDayOfMonth.diff(firstDayOfWeek, 'days');

    return Math.ceil((input.date() + offset) / 7) ;
}

function isToday(friendlyDate) {
    const date = new Date(friendlyDate);
    
    const today = new Date();
    
    return date.getFullYear() === today.getFullYear() &&
           date.getMonth() === today.getMonth() &&
           date.getDate() === today.getDate();
}

class YearViewCalendar extends React.Component {
    constructor(props) {
        super();
        this.state = {
            flightInfo: [],
            modalShown: false,
        };
        moment.locale(props.language);
        this.onDateClicked = this.onDateClicked.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        moment.locale(nextProps.language);
    }

    onDateClicked(flightInfo) {
        if (flightInfo && flightInfo.length > 0) {
            this.setState({
                modalShown: true,
                flightInfo,
            });
        }
    }

    defineDataStructure(year) {
        return _.times(12, (month) => {
            const lastDayMonth = getLastDayOfMonth(year, (month + 1));
            const monthlyStructure = [];
            _.times(lastDayMonth, (day) => {
                const currentDate = moment(`${year}-${(month + 1).toString().padStart(2, '0')}-${(day + 1).toString().padStart(2, '0')}`);
                const week = weekOfMonth(currentDate);
                monthlyStructure[week] = monthlyStructure[week] || {};
                monthlyStructure[week][currentDate.format('ddd')] = {
                    year: currentDate.year(),
                    month: currentDate.month() + 1,
                    date: currentDate.date(),
                    dayName: currentDate.format('ddd'),
                    dayOfWeek: currentDate.day(),
                    friendlyDate: currentDate.format('YYYY-MM-DD'),
                };
            });
            return monthlyStructure;
        });
    }

    render() {
        const { year, flightInformation } = this.props;
        const dataStructure = this.defineDataStructure(year);
        const weekdayNames = _.times(7, (index) => {
            const day = moment(`2019-01-0${index + 1}`);
            return {
                dayName: day.format('ddd'),
                dayNameLong: day.format('dddd'),
                order: day.day(),
            };
        }).sort((a, b) => {
            if (a.order < b.order) return -1;
            if (a.order > b.order) return 1;
            return 0;
        });
        const { modalShown, flightInfo } = this.state;

        return (
            <div className="year-view-calendar">
                {
                    dataStructure.map((month, index) => {
                        const id = shortid.generate();
                        // eslint-disable-next-line react/no-array-index-key
                        return (
                            <div className="month-view" key={id}>
                                <h3>{moment(`${year}-${(index + 1).toString().padStart(2, '0')}-01`).format('MMMM YYYY')}</h3>
                                <table className="table table-striped">
                                    <thead>
                                        <tr>
                                            {weekdayNames.map(weekDay => <td key={`${id}${weekDay.dayName}`}>{weekDay.dayName}</td>)}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {month.map((week, indexWeek) => (
                                            <tr key={`${id}week${shortid.generate()}`}>
                                                {_.times(7, (index2) => {
                                                    let searchedDate = null;
                                                    Object.keys(week).forEach((key) => {
                                                        if (week[key].dayOfWeek === index2) searchedDate = week[key];
                                                    });
                                                    let el = null;
                                                    
                                                    
                                                    if (searchedDate !== null) {
                                                        const searchFlight = flightInformation.filter(o => moment(o.Departure_Date_Time__c).format('YYYY-MM-DD') === searchedDate.friendlyDate);
                                                        let className = '';
                                                        let isCruises = false;
                                                        let isAlternative = false;
                                                        if (searchFlight.length > 0) {
                                                            if (searchFlight.find(o => o.Flight_Type__c === null || o.Flight_Type__c === '' || o.Flight_Type__c === 'Regular')) {
                                                                className += 'has-flight';
                                                                
                                                            }
                                                            if (searchFlight.find(o => o.Holiday_Season__c === true)) {
                                                                className += ' holiday-season';
                                                            }
                                                            if (searchFlight.find(o => o.RecordType.Name === 'Cruises')) {
                                                                className += ' with-cruises';
                                                                isCruises = true;
                                                            }
                                                            if (searchFlight.find(o => o.Flight_Type__c === 'Alternative')) {
                                                                className += ' alternative-flight';
                                                                isAlternative = true;
                                                            }
                                                        }
                                                        if(isToday(searchedDate.friendlyDate)){
                                                            className += ' todays-date'
                                                        }
                                                        el = (
                                                            <Link
                                                                to={`${URL_PREFIX}/app/calendar/${searchedDate.friendlyDate}`}
                                                                className={className}
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    this.onDateClicked(searchFlight);
                                                                }}
                                                            >
                                                                {isCruises ? [<span className="flight" />, <span className="cruises" />] : null}
                                                                <span className="date">{searchedDate.date}</span>
                                                            </Link>
                                                        );
                                                    }
                                                    return (
                                                        <td>
                                                            {searchedDate ? el : null}
                                                        </td>
                                                    );
                                                })}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        );
                    })
                }
                <Modal
                    isOpen={modalShown}
                    onRequestClose={() => this.setState({ modalShown: false, flightInfo: [] })}
                    className="calendar-action"
                    ariaHideApp={false}
                >
                    {
                        flightInfo.length > 0 ?
                            <div className="">
                                <h3>{moment(flightInfo[0].Departure_Date_Time__c).format('dddd, DD-MMM-YYYY')}</h3>
                                <div className="action-list">
                                    <Link to={`${URL_PREFIX}/app/ama?date=${moment(flightInfo[0].Departure_Date_Time__c).format('YYYY-MM-DD')}`}>
                                        <p>Availability Management</p>
                                        <img src={require('../../static/img/icons/png/admin-laptop.png')} alt="AMA" />
                                    </Link>
                                    <Link to={`${URL_PREFIX}/app/guest-list/${moment(flightInfo[0].Departure_Date_Time__c).format('YYYY-MM-DD')}`}>
                                        <p>Guest List</p>
                                        <img src={require('../../static/img/icons/png/guest-list.png')} alt="GuestList" />
                                    </Link>
                                </div>
                            </div> : null
                    }
                </Modal>
            </div>
        );
    }
}


YearViewCalendar.propTypes = {
    year: PropTypes.number,
    language: PropTypes.string,
    flightInformation: PropTypes.any.isRequired,
};

YearViewCalendar.defaultProps = {
    year: moment().year(),
    language: 'en',
};

export default YearViewCalendar;
